"use client";

import { BookOpen, Compass, Users } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Contatto Telefonico",
  description: "+39 02 8765 4321. Linea diretta per consulenze legali urgenti e coordinamento immediato delle pratiche.",
  icon: Compass
}, {
  title: "Corrispondenza Digitale",
  description: "segreteria@studiolegale.it. Canale preferenziale per l'invio di atti, documenti e richieste di pareri tecnici.",
  icon: Users
}, {
  title: "Sede di Rappresentanza",
  description: "Via della Conciliazione, 15, Roma. Consultazioni private in sede disponibili esclusivamente su appuntamento.",
  icon: BookOpen
}];
export default function InfoColumns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}